import { List } from 'antd'
import React, { useEffect, useState, useMemo } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux'
import { type RootState } from '../../../../store/store'
import { getStatusesOffers } from '../../../../functions/agent/schedule/getStatusesOffers'
import OfferListItem from './OfferListItem'
import { type IOffer, offersSlice } from '../../../../store/slices/offersSlice'


import {
    prImage,
    othrImage,
    rejImage,
    aprImage,
    completedImage,
    resubmitRequiredImage,
    cancelledImage, negotiatedImage, confirmedImage,
    placeholders
} from '../../../../urls'
import { ScheduleAccordion } from '../ScheduleAccordion'

interface IProps {
    offers: IOffer[]
}

export default function OffersList({ offers }: IProps): JSX.Element {
    // let statuses: any = []
    // statuses = getStatusesOffers(offers)
    const statuses = useMemo(() => getStatusesOffers(offers), [offers]);
    const filterNavigate = useAppSelector((state: RootState) => state.schedule.filterNavigate)
    const offersScrollPosition = useAppSelector((state: RootState) => state.offers.offersScrollPosition)
    const dispatch = useAppDispatch()
    const [expanded, setExpanded] = useState<string | false>(false);





    useEffect(() => {
        if (filterNavigate === 'offers') {
            setTimeout(() => {
                window.scrollTo({ top: Number(offersScrollPosition), behavior: 'smooth' })
            }, 100)
        }
    }, [filterNavigate])

    useEffect(() => {
        const scrollWrapper = document.querySelector('#root')
        const handleScroll = (event: Event): void => {
            const target = event?.target as HTMLElement
            if (target.scrollTop > 0) {
                dispatch(offersSlice.actions.setOffersScrollPosition(target.scrollTop))
            }
        }
        scrollWrapper?.addEventListener('scroll', handleScroll, { passive: true })
        return () => {
            ///    dispatch(offersSlice.actions.setOffersScrollPosition(offersScrollPosition + 2))
            scrollWrapper?.removeEventListener('scroll', handleScroll)
        }
    }, [filterNavigate])


    const statusImages: any = {
        Approved: aprImage,
        Rejected: rejImage,
        Canceled: cancelledImage,
        Completed: completedImage,
        'In-process': prImage,
        'Client docs required': prImage,
        'Resubmit required': resubmitRequiredImage,
        'Negotiated offers': negotiatedImage,
        Confirmed: confirmedImage,
        "Other": othrImage
    }


    return (
        <div>
            {statuses && statuses.length > 0 ? (
                statuses.map((item: any) =>
                    item.offersLength > 0 ? (
                        <ScheduleAccordion
                            key={item.status}
                            group={item.status}
                            expanded={expanded}
                            setExpanded={setExpanded}
                            countLable={item.offersLength}
                            imgCover={statusImages[item.status] || statusImages['Other']}
                        >

                            <OfferListItem
                                key={item.id} {...item} />

                        </ScheduleAccordion>
                    ) : null
                )
            ) : (
                <div className={'d-flex position-relative align-items-end'}>
                    <img
                        className="w-75 object-fit-cover m-auto rounded rounded-4 opacity-100 mt-8"
                        src={placeholders.Offers}
                        alt={'liable_picture'}
                    />
                    <span className="fs-2x fs-lg-2 fw-bold text-white text-uppercase position-absolute text-center"
                        style={{ bottom: '14%', left: '50%', transform: 'translateX(-50%)', textShadow: '1px 1px 10px #332d2dd9' }}>
                        You don’t have any active offers yet
                    </span>
                </div>
            )}
        </div>
    )
}
